"use client";

import { getPageColorsFromRoute } from "@/lib/navigation";
import { PageColorProvider } from "@/components/public/PageColorProvider";

interface PublicBackgroundProps {
  page?: string;
  fullPath?: string;
}

export function PublicBackground({ page, fullPath }: PublicBackgroundProps) {
  const route = fullPath || (page ? `/${page}` : "/");
  const pageColors = getPageColorsFromRoute(route);

  return (
    <>
      <PageColorProvider path={route} />
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 -z-10 overflow-hidden pointer-events-none">
          {/* Clean white background - full page */}
          <div className="absolute inset-0 bg-white" />

          {/* Horizontal dashed line under header tabs */}
          <div
            className="absolute top-16 left-0 right-0 h-px z-20"
            style={{
              borderTop: "1px dashed #e2e8f0",
              borderImageSource:
                "repeating-linear-gradient(to right, #e2e8f0 0px, #e2e8f0 4px, transparent 4px, transparent 8px)",
              borderImageSlice: 1,
            }}
          />

          {/* Full-width 6-column grid system - similar to Stripe */}
          <div className="absolute inset-0 z-10">
            <div className="relative w-full h-full">
              
              {/* Column backgrounds removed (visual debug) - grid lines remain visible */}

              {/* 6-Column Grid System (16.67% each) */}
              {/* Only show grid lines for the middle 4 columns - columns 1 and 6 are invisible */}
              
              {/* Column 1 boundary - INVISIBLE (far left edge) */}
              
              {/* Column 2 boundary (16.67%) - VISIBLE */}
              <div
                className="hidden xl:block absolute top-0 w-px h-full"
                style={{
                  left: "16.67%",
                  borderLeft: "1px dashed #e2e8f0",
                  borderImageSource:
                    "repeating-linear-gradient(to bottom, #e2e8f0 0px, #e2e8f0 4px, transparent 4px, transparent 8px)",
                  borderImageSlice: 1,
                }}
              />

              {/* Column 3 boundary (33.33%) - VISIBLE */}
              <div
                className="hidden xl:block absolute top-0 w-px h-full"
                style={{
                  left: "33.33%",
                  borderLeft: "1px dashed #e2e8f0",
                  borderImageSource:
                    "repeating-linear-gradient(to bottom, #e2e8f0 0px, #e2e8f0 4px, transparent 4px, transparent 8px)",
                  borderImageSlice: 1,
                }}
              />

              {/* Column 4 boundary (50% - center) - VISIBLE */}
              <div
                className="hidden md:block absolute top-0 w-px h-full"
                style={{
                  left: "50%",
                  borderLeft: "1px dashed #e2e8f0",
                  borderImageSource:
                    "repeating-linear-gradient(to bottom, #e2e8f0 0px, #e2e8f0 4px, transparent 4px, transparent 8px)",
                  borderImageSlice: 1,
                }}
              />

              {/* Column 5 boundary (66.67%) - VISIBLE */}
              <div
                className="hidden xl:block absolute top-0 w-px h-full"
                style={{
                  left: "66.67%",
                  borderLeft: "1px dashed #e2e8f0",
                  borderImageSource:
                    "repeating-linear-gradient(to bottom, #e2e8f0 0px, #e2e8f0 4px, transparent 4px, transparent 8px)",
                  borderImageSlice: 1,
                }}
              />

              {/* Column 6 boundary (83.33%) - VISIBLE */}
              <div
                className="hidden xl:block absolute top-0 w-px h-full"
                style={{
                  left: "83.33%",
                  borderLeft: "1px dashed #e2e8f0",
                  borderImageSource:
                    "repeating-linear-gradient(to bottom, #e2e8f0 0px, #e2e8f0 4px, transparent 4px, transparent 8px)",
                  borderImageSlice: 1,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
